module.exports = __webpack_public_path__ + "media/images/emblems/Schongau_LU-1371c19bfdc6f7de3d2367a10d6c1866.png";